const KeenSlider = window.KeenSlider

const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class LifestyleCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    let slideAmount = this.dataset.slides
    if (slideAmount > 4) {
      slideAmount = 4.65

      if (window.BAO.MediaBreakpoints.isXxlg) {
        slideAmount = 5
      }
    }

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 2.1,
          spacing: 20,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.65,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.65,
              spacing: 20,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: slideAmount,
              spacing: 20,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('lifestyle-carousel')) {
  customElements.define('lifestyle-carousel', LifestyleCarousel)
}
